import { EnumsMap } from "features/shared/enums/EnumsMap"

export const getEnumValuesByKey = (enumName: string): string[] => {
  let result: string[] = [];
  let enumObj = EnumsMap[enumName];
  
  if (enumObj) {
    return Object.keys(enumObj);
  }

  return result;
}